module.exports = __webpack_public_path__ + "img/btn02.200108cf.png";